<template>
  <div id="disk" style="display: flex;min-width: 1100px;">
    <el-menu ref="nav" :default-active="computedActive" class="el-menu-vertical-demo app-navigation"
             :collapse="false" :style="{height: computedHeight+'px'}" style="overflow-y: scroll;
    overflow-x: hidden;">
      <el-menu-item v-for="(nav, idx) in navList" :index="nav.tagId" :key="idx+10" @click="clickTag(nav)">
        <div class="tag-posi" align="left">
          <i :class="nav.class"></i>
          <span slot="title">{{nav.tagName}}</span>
        </div>
      </el-menu-item>
      <el-submenu index="1" v-if="tagTag[0]">
        <template slot="title">
          <div class="tag-posi" align="left">
            <i :class="tagTag[0].class"></i>
            <span>{{tagTag[0].tagName}}</span>
          </div>
        </template>
        <el-menu-item-group>
          <el-menu-item ref="tag" v-for="(item) in tagChild" :index="item.tagId" :key="item.tagId"  @click="clickTag(item)">
            <div :ref="item.elementId" :id="item.elementId" @mouseover="hoverTagChild(item)" @mouseout="leaveTagChild(item)"
                 class="tag-posi" align="left" style="display: -webkit-box;">
              <el-color-picker size="mini"
                               v-model="item.color"
                               show-alpha
                               @change="changeColor"
                               :predefine="predefineColors">
              </el-color-picker>
              <div slot="title" style="margin-left: 10px;">
                <el-popover trigger="hover" :open-delay=500>
                  <p>{{ item.tagName }}</p>
                  <div slot="reference" class="name-wrapper">
                    <span class="too-long">{{item.tagName}}</span>
                  </div>
                </el-popover>
              </div>
            </div>
          </el-menu-item>
          <el-button type="text" @click="addTag" style="color: #606266;" icon="el-icon-circle-plus">新建标签</el-button>
        </el-menu-item-group>
      </el-submenu>
      <!--<el-menu-item v-for="(nav, idx) in shareTag" :index="nav.tagId" :key="idx + 100" @click="clickTag(nav)">-->
        <!--<div class="tag-posi" align="left">-->
          <!--<i :class="nav.class"></i>-->
          <!--<span slot="title">{{nav.tagName}}</span>-->
        <!--</div>-->
      <!--</el-menu-item>-->
      <el-menu-item v-for="(nav, idx) in deleteTag" :index="nav.tagId" :key="idx" @click="clickTag(nav)">
        <div class="tag-posi" align="left">
          <i :class="nav.class"></i>
          <span slot="title">{{nav.tagName}}</span>
        </div>
      </el-menu-item>

    </el-menu>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <el-dialog
      :title="tagDialogTitle"
      :visible.sync="centerDialogVisible"
      width="350px"
      top="20%">
      <el-input
        :placeholder="tagDialogPlaceHolder"
        v-model="inputTagName"
        clearable>
      </el-input>
      <div style="display: flex; flex-direction: row;margin-top: 12px;">
        <span class="demonstration" style="padding: 4px 10px 0 0;">选择颜色</span>
        <el-color-picker size="mini"
                         v-model="selectedColor"
                         show-alpha
                         :predefine="predefineColors">
        </el-color-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--clickConfirmRenameTag-->
        <el-button v-if="operateTagType===1" type="primary" size="mini" @click="clickConfirmAddTag">确 定</el-button>
        <el-button v-else-if="operateTagType===2" type="primary" size="mini" @click="clickConfirmRenameTag">确 定</el-button>
      </span>
    </el-dialog>
    <context-menu class="right-menu"
                  :show="contextMenuVisible === 'tag'" :target="'tag'"
                  @update:show="(show) => contextMenuVisible = show">
      <el-button class="btn-tag" type="text" @click="clickRenameTag">重命名标签</el-button>
      <div class="line-div"></div>
      <!--<el-button class="btn-tag" type="text" @click="clickAddColor" style="padding-bottom: 0;padding-left: 0;">修改颜色</el-button>-->
      <el-button class="btn-tag" type="text" @click="clickDeleteTag(1)">删除标签</el-button>
    </context-menu>
  </div>
</template>

<script>
import ct from '../utils/constant.js'
import { mapMutations, mapState } from 'vuex'
// import {dtFormat} from '../utils/utils.js'
import contextMenu from '../components/VueContextMenu.vue'
export default {
  name: 'App',
  created () {
  },
  mounted () {
    window.addEventListener('resize', this.screenSizeHandler)
  },
  data () {
    return {
      contextMenuVisible: '',
      centerDialogVisible: false,
      computedTop: window.innerHeight - 590 - 56 * 4,
      bannerList: [
        {id: 1, name: 'banner1', path: 'cafe.jpg'},
        {id: 2, name: 'banner2', path: 'play-street.jpg'},
        {id: 3, name: 'banner3', path: 'cosmea.jpg'},
        {id: 4, name: 'banner4', path: 'cafe.jpg'}
      ],
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      baseUrl: 'static/img/',
      deleteTag: [],
      tagTag: [],
      tagChild: [],
      shareTag: [],
      navList: [],
      inputTagName: '',
      contextMenuTag: {},
      operateTagType: null,
      tagDialogTitle: '',
      tagDialogPlaceHolder: '',
      showColorSelect: '',
      selectedColor: '#409EFF'
    }
  },
  components: {
    contextMenu
  },
  watch: {
    'tagsList': function (val) {
      // console.log('tagsList', val)
      let res = []
      let del = []
      let tag = []
      let share = []
      let tagChild = []
      this.tagsList.forEach(t => {
        let obj = {}
        let cate = t.category
        let type = t.tagType
        // console.log(ct.TagIds, t.category)
        obj.path = ct.TagIds[t.category].path
        // obj.rName = ct.TagIds[t.category].name
        obj.class = ct.TagIds[t.category].class
        obj.addFlag = ct.TagIds[t.category].addFlag
        obj.category = cate
        obj.tagName = t.tagName
        // obj.createDT = dtFormat(t.createDT)
        // obj.creator = t.creator
        obj.tagType = type
        obj.tagId = t.tagId
        obj.elementId = t.tagId
        obj.color = t.color
        if (cate === ct.TagCategory.all) {
          res.push(obj)
        } else if (cate === ct.TagCategory.tag) {
          if (type === 1) {
            tag.push(obj)
          } else {
            tagChild.push(obj)
          }
        } else {
          del.push(obj)
        }
      })
      this.tagTag = tag
      this.deleteTag = del
      this.shareTag = share
      this.tagChild = tagChild
      this.navList = res
    }
  },
  methods: {
    ...mapMutations(['setToolBarLeft', 'setFilesList', 'setCurrentTag', 'setTagsList', 'setContextMenuElement', 'setTarget', 'setSrcPage']),
    screenSizeHandler () {
      this.computedTop = this.computedHeight - 400 - 56 * 4 - 238
      if (this.computedTop < 30) {
        this.computedTop = 30
      }
    },
    clickTag (tag) {
      // console.log('clickTag')
      this.setStorage('urlFlagParam', null)
      this.setStorage('urlFGuidParam', null)
      let target = null
      if (this.isArrange) {
        target = document.getElementById('app_content_file_card')
      } else {
        target = document.getElementById('app_content_file_table')
      }
      let loading = this.$loading({text: '拼命加载中', target: target, spinner: 'el-icon-loading'})
      if (tag.category === ct.TagCategory.all) {
        this.postRequest('loadFilesByFileGuid', {startIndex: 0, pageSize: 0, orderColumn: ct.OrderColumn.updateDT, isDesc: true, parentGuid: this.rootFile.fileGuid}).then(res => {
          if (res) {
            this.setFilesList(res.data.result)
            loading.close()
          }
        })
      } else {
        if (tag.category !== ct.TagCategory.share) {
          this.postRequest('loadFilesByTag', {orderColumn: ct.OrderColumn.updateDT, isDesc: true, tagId: tag.tagId}).then(res => {
            if (res) {
              this.setFilesList(res.data.result)
              loading.close()
            }
          })
        } else {
          loading.close()
        }
      }
      this.setCurrentTag(tag)
      if (tag.tagName === ct.RouterData.allFile.label) {
        this.setSrcPage(ct.SrcPage.all)
      } else if (tag.tagName === ct.RouterData.tagFile.label) {
        this.setSrcPage(ct.SrcPage.tag)
      } else if (tag.tagName === ct.RouterData.delFile.label) {
        this.setSrcPage(ct.SrcPage.delete)
      } else if (tag.tagName === ct.RouterData.myShare.label) {
        this.setSrcPage(ct.SrcPage.myShare)
      } else if (tag.tagName === ct.RouterData.myCommon.label) {
        this.setSrcPage(ct.SrcPage.myCommon)
      } else {
        this.setSrcPage(ct.SrcPage.tag)
      }
      // console.log('setCurrentTag')
      // this.$router.push({name: tag.rName, query: {tagId: tag.tagId}, params: {tag: tag}})
      this.$router.push({path: tag.path, query: {tagId: tag.tagId, tag: JSON.stringify(tag)}})
    },
    addTag () {
      this.tagDialogTitle = '新建标签'
      this.tagDialogPlaceHolder = '请输入新建标签'
      this.centerDialogVisible = true
      this.operateTagType = 1
    },
    changeColor (val) {
      if (val === null) {
        val = 'rgba(185, 190, 194, 1)'
      }
      this.postRequest('changeTagColor', {tagId: this.contextMenuTag.tagId, color: val}).then(res => {
        if (res) {
          this.tagChangeHandler(res)
        }
      })
    },
    clickConfirmAddTag () {
      if (this.selectedColor === null) {
        this.selectedColor = 'rgba(185, 190, 194, 1)'
      }
      this.centerDialogVisible = false
      this.postRequest('addTag', {tagName: this.inputTagName, color: this.selectedColor}).then(res => {
        if (res) {
          let list = this.tagsList
          list.unshift(res.data.result)
          this.setTagsList(list)
          this.inputTagName = ''
        }
      })
    },
    clickRenameTag () {
      this.tagDialogTitle = '重命名标签'
      this.tagDialogPlaceHolder = '请输入重命名标签'
      this.centerDialogVisible = true
      this.operateTagType = 2
      this.inputTagName = this.contextMenuTag.tagName
    },
    tagChangeHandler (res) {
      let list = this.tagsList
      let index = null
      for (let i = 0; i < list.length; i++) {
        if (list[i].tagId === this.contextMenuTag.tagId) {
          index = i
          break
        }
      }
      list.splice(index, 1, res.data.result)
      this.setTagsList(list)
    },
    clickConfirmRenameTag () {
      if (!this.inputTagName || this.inputTagName === '') {
        this.$message({message: '请输入标签名称', type: 'error'})
        return
      }
      this.centerDialogVisible = false
      this.postRequest('renameTag', {tagId: this.contextMenuTag.tagId, tagName: this.inputTagName}).then(res => {
        if (res) {
          this.tagChangeHandler(res)
        }
        this.inputTagName = ''
      })
    },
    clickDeleteTag (type) {
      if (type === 1) { // 删除
        this.postRequest('deleteTag', {tagId: this.contextMenuTag.tagId, type: type}).then(res => {
          if (!res.data.result && type === 1) { // 没有返回提示信息，直接删除
            this.confirmDelete('确认删除标签：' + this.contextMenuTag.tagName)
          }
          if (res.data.result) {
            this.confirmDelete(res.data.result)
          }
        })
      } else { // 确认删除
        this.postRequest('deleteTag', {tagId: this.contextMenuTag.tagId, type: type}).then(res => {
          let list = this.tagsList
          list = list.filter(l => l.tagId !== this.contextMenuTag.tagId)
          this.setTagsList(list)
        })
      }
    },
    clickAddColor () {
      this.showColorSelect = true
    },
    confirmDelete (msg) {
      this.$confirm(msg, '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.clickDeleteTag(2)
      }).catch(action => {
      })
    },
    hoverTagChild (tag) {
      this.setContextMenuElement(this.$refs[tag.elementId][0])
      this.setTarget('tag')
      this.contextMenuTag = tag
      // this.contextMenuTarget = document.getElementById(tag.elementId)
    },
    leaveTagChild (tag) {
      // todo
    }
  },
  computed: {
    ...mapState(['computedHeight', 'computedWidth', 'tagsList', 'rootFile', 'currentTag', 'isArrange']),
    computedActive () {
      /**
       * if (this.currentTag.tagId) {
        return this.currentTag.tagId
      } else if (this.tagsList.find(t => t.category === 1)) {
        return this.tagsList.find(t => t.category === 1).tagId
      } else {
        return ''
      }
       */
      let q = this.$route.query.tagId
      if (q) {
        return q
      }
      return this.currentTag.tagId
    }
  }
}
</script>

<style>
  #disk .el-menu {
  }

  #disk .el-menu-item-group__title {
    padding: 0 0 0 20px;
  }

  .right-menu {
    position: fixed;
    background: #fff;
    /*border: solid 1px rgba(0, 0, 0, .2);*/
    z-index: 999;
    display: none;
    border: 1px solid #eee;
    box-shadow: 0 0.5em 1em 0 rgba(0,0,0,.1);
    border-radius: 1px;
    flex-direction: column;
  }

  .btn-tag {
    padding: 15px;
    margin-left: 0;
    /*height: 33px;*/
    /*line-height: 33px;*/
    /*color: #5b667b!important;*/
  }

  .tag-posi {
    /*float: left;*/
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/NetworkDisk.vue